<template>
  <div class="content">
    <title-bar :title="$lang.VIP"> </title-bar>
    <div v-if="vipReadError" class="vip-read-diagnostic">
      {{ vipReadError }}
    </div>
    <!-- <img
      src="../../../assets/img/vip/vip-bg.jpg"
      width="100%"
      style="position: relative"
    /> -->
    <div class="content-info2">
      <div style="width: 100%">
        <div class="content-info2--c d-flex">
          <div class="d-flex-s m-t-5" style="width: 100%">
            <div class="d-flex m-l-10">
              <img
                :src="
                  require(`@/assets/img/vip/V${
                    InitDate2.vipLevel != null ? InitDate2.vipLevel : 0
                  }.png`)
                "
                width="65"
                style="z-index: 9"
              />
              <div class="vip-tag">
                <p
                  class="content-info2--t"
                  style="
                    font-style: italic;
                    font-size: var(--vk-fs-2xl);
                    font-weight: 900;
                    color: #7b6845;
                  "
                >
                  {{ $lang.VIP }}
                  {{ InitDate2.vipLevel }}
                </p>
              </div>
              <!-- <p style="font-weight: bold; color: #7b6845; margin-left: 12px">
                {{ $lang.common_txt }}
              </p> -->
            </div>
          </div>
        </div>
        <div class="d-flex m-l-10" style="margin-top: 5px">
          <van-progress
            class="progress-bg"
            :percentage="parseInt(percentage)"
            track-color="#575130"
            stroke-width="14"
            :show-pivot="false"
          />
          <div class="d-flex m-l-5">
            <img
              :src="
                require(`@/assets/img/vip/V${
                  InitDate2.vipLevel != null ? InitDate2.vipLevel + 1 : 0
                }.png`)
              "
              width="30"
              style="z-index: 9"
            />
            <div v-if="InitDate2.vipLevel" class="vip-tag2">
              <p class="content-info2--t">
                {{ $lang.VIP }}
                {{ InitDate2.vipLevel + 1 }}
              </p>
            </div>
          </div>
        </div>
        <p class="m-t-10 m-l-10" style="font-weight: 800; color: #7b6845">
          {{ $lang.common_txt2 }}
        </p>

        <div class="d-flex m-t-10 f-w">
          <div class="content-info2--ct m-l-10" style="color: #7b6845">
            <p>
              • {{ $lang.common_txt3 }}
              <span
                v-if="
                  InitDate2.nextRechargeAmount - InitDate2.rechargeAmount > 0
                "
                style="color: #d52d49"
                class="f-t-13 f-w m-l-5"
                >{{
                  $formatNumberWithCommas(
                    InitDate2.nextRechargeAmount - InitDate2.rechargeAmount
                  )
                }}</span
              ><span v-else style="color: #d52d49" class="f-t-13 f-w m-l-5"
                >0</span
              ><span style="color: #7b6845; margin-left: 8px"
                >({{
                  InitDate2.rechargeAmount != 0
                    ? $formatNumberWithCommas(InitDate2.rechargeAmount)
                    : '0'
                }}
                /
                {{
                  InitDate2.nextRechargeAmount != 0
                    ? $formatNumberWithCommas(InitDate2.nextRechargeAmount)
                    : '0'
                }})</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
    <p style="margin: 20px 0 25px 10px; font-size: var(--vk-fs-md); font-weight: bold">
      {{ $lang.common_txt4 }}
    </p>
    <div class="content-c3">
      <div class="content-c3--t font-color">
        <p>{{ $lang.vip_txt4 }}</p>
        <p v-html="$lang.vip_txt5"></p>
        <p v-html="$lang.vip_txt6"></p>
        <p v-html="$lang.vip_txt7"></p>
        <p v-html="$lang.vip_txt8"></p>
      </div>

      <div
        class="content-c3--t2"
        v-for="(item, index) in InitDate"
        :key="index"
        :style="(index + 1) % 2 === 0 ? {} : { backgroundColor: '#454654' }"
      >
        <div class="d-flex" style="width: 20%">
          <div class="d-flex">
            <img
              style="z-index: 9"
              :src="require(`@/assets/img/vip/V${index}.png`)"
              width="28"
            />
            <span class="vip-tag3">VIP{{ item.vipLevel }}</span>
          </div>
        </div>

        <p>{{ $formatNumberWithCommas(item.rechargeAmount) }}</p>
        <p>{{ $formatNumberWithCommas(item.upgradeBonus) }}</p>
        <p>{{ $formatNumberWithCommas(item.signReward) }}</p>
        <p>{{ $formatNumberWithCommas(item.monthlyBonus) }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { VipInit } from '@/api/common'
import { contentOf, failMessage, handleNeedLogin, isOk, toArray, toNumber } from './safeFlow'

const VIP_LIST_KEYS = ['vipList', 'vip_list', 'list', 'records', 'dataList', 'items', 'pageList']
const VIP_ENVELOPE_KEYS = ['content', 'data', 'payload', 'page', 'body', 'records', 'extra']

function fallbackToken(value) {
  return String(value == null ? '' : value).trim().toLowerCase()
}

function hasReadFallbackMarker(payload, depth = 0, seen = []) {
  if (!payload || typeof payload !== 'object' || depth > 6 || seen.includes(payload)) return false
  seen.push(payload)
  if (Array.isArray(payload)) {
    return payload.some(item => hasReadFallbackMarker(item, depth + 1, seen))
  }
  return Object.keys(payload).some(key => {
    const value = payload[key]
    const keyToken = fallbackToken(key)
    const valueToken = fallbackToken(value)
    if (keyToken.includes('fallback') && (value === true || value === 1 || ['true', '1', 'yes', 'on'].includes(valueToken) || valueToken.includes('fallback'))) return true
    if (value && typeof value === 'object') return hasReadFallbackMarker(value, depth + 1, seen)
    return valueToken.includes('fallback')
  })
}

function isOkStatusValue(value) {
  return ['ok', 'success', 'successful', 'succeed', 'succeeded', '0', '00', '0000', '000000', '200'].includes(fallbackToken(value))
}

function hasOkReadStatus(res) {
  if (!res || typeof res !== 'object') return false
  return [res.status, res.state, res.result, res.code, res.errorCode, res.success].some(value => value === true || isOkStatusValue(value))
}

function isReadUnavailableText(value) {
  const token = fallbackToken(value)
  if (!token || token.includes('unblocked') || token.includes('not blocked')) return false
  return token.includes('backend_blocked') ||
    token.includes('backendblocked') ||
    token.includes('backend blocked') ||
    token.includes('backend-blocked') ||
    token.includes('backend_failure') ||
    token.includes('backendfailure') ||
    token.includes('backend failure') ||
    token.includes('backend-failure') ||
    token.includes('technical_marker') ||
    token.includes('technicalmarker') ||
    token.includes('technical marker') ||
    token.includes('technical-marker') ||
    token.includes('payment_backend_blocked') ||
    token.includes('paymentbackendblocked') ||
    token.includes('payment backend blocked') ||
    token.includes('payment-backend-blocked') ||
    token.includes('unavailable') ||
    token.includes('data_unavailable') ||
    token.includes('dataunavailable') ||
    token.includes('data unavailable') ||
    token.includes('data-unavailable') ||
    token.includes('read_unavailable') ||
    token.includes('readunavailable') ||
    token.includes('read unavailable') ||
    token.includes('read-unavailable') ||
    token.includes('read_blocked') ||
    token.includes('readblocked') ||
    token.includes('read blocked') ||
    token.includes('read-blocked') ||
    token.includes('read_only') ||
    token.includes('readonly') ||
    token.includes('read only') ||
    token.includes('read-only') ||
    token === 'blocked'
}

function isReadDiagnosticTextKey(key) {
  return [
    'status',
    'state',
    'result',
    'code',
    'errorcode',
    'msg',
    'message',
    'errormsg',
    'errormessage',
    'reason',
    'desc',
    'description'
  ].includes(fallbackToken(key))
}

function hasActiveReadFallbackFlag(payload, depth = 0, seen = []) {
  if (!payload || typeof payload !== 'object' || depth > 6 || seen.includes(payload)) return false
  seen.push(payload)
  if (Array.isArray(payload)) return payload.some(item => hasActiveReadFallbackFlag(item, depth + 1, seen))
  return Object.keys(payload).some(key => {
    const value = payload[key]
    const keyToken = fallbackToken(key)
    const valueToken = fallbackToken(value)
    if (['success', 'statusProof', 'status_proof', 'writeProof', 'write_proof'].includes(key) && (value === false || valueToken === 'false' || valueToken === '0')) return true
    if (['status', 'state', 'result'].includes(key) && ['fail', 'failed', 'failure', 'error', 'rejected', 'reject', 'disabled'].includes(valueToken)) return true
    if (['code', 'errorCode'].includes(key) && valueToken && !isOkStatusValue(valueToken) && (/^[45]\d{2,}$/.test(valueToken) || valueToken.startsWith('e_'))) return true
    if (
      keyToken.includes('fallback') ||
      keyToken.includes('readonly') ||
      keyToken.includes('read_only') ||
      keyToken.includes('failed') ||
      keyToken.includes('failure') ||
      keyToken.includes('unimplemented') ||
      keyToken.includes('not_supported') ||
      keyToken.includes('notconnected') ||
      keyToken.includes('not_connected') ||
      keyToken.includes('dataunavailable') ||
      keyToken.includes('data_unavailable') ||
      keyToken.includes('unavailable') ||
      keyToken.includes('readunavailable') ||
      keyToken.includes('read_unavailable') ||
      keyToken.includes('readblocked') ||
      keyToken.includes('read_blocked') ||
      keyToken.includes('readfailure') ||
      keyToken.includes('read_failure') ||
      keyToken.includes('writeblocked') ||
      keyToken.includes('write_blocked') ||
      keyToken.includes('backendblocked') ||
      keyToken.includes('backend_blocked') ||
      keyToken.includes('backend-blocked') ||
      keyToken.includes('backendfailure') ||
      keyToken.includes('backend_failure') ||
      keyToken.includes('backend-failure') ||
      keyToken.includes('technicalmarker') ||
      keyToken.includes('technical_marker') ||
      keyToken.includes('technical-marker') ||
      keyToken.includes('paymentbackendblocked') ||
      keyToken.includes('payment_backend_blocked') ||
      keyToken.includes('payment-backend-blocked') ||
      keyToken === 'mock' ||
      keyToken === 'stub' ||
      keyToken === 'blocked'
    ) {
      return value === true || value === 1 || ['true', '1', 'yes', 'on'].includes(valueToken) || valueToken.includes('fallback')
    }
    if (value && typeof value === 'object') return hasActiveReadFallbackFlag(value, depth + 1, seen)
    return false
  })
}

function hasReadUnavailableTextMarker(payload, depth = 0, seen = []) {
  if (!payload || typeof payload !== 'object' || depth > 6 || seen.includes(payload)) return false
  seen.push(payload)
  if (Array.isArray(payload)) return payload.some(item => hasReadUnavailableTextMarker(item, depth + 1, seen))
  return Object.keys(payload).some(key => {
    const value = payload[key]
    if (value && typeof value === 'object') return hasReadUnavailableTextMarker(value, depth + 1, seen)
    return isReadDiagnosticTextKey(key) && isReadUnavailableText(value)
  })
}

function isReadOk(res) {
  const content = contentOf(res)
  return (isOk(res) || hasOkReadStatus(res)) &&
    !hasActiveReadFallbackFlag(res) &&
    !hasReadFallbackMarker(content) &&
    !hasReadUnavailableTextMarker(content)
}

function hasValue(value) {
  return value !== undefined && value !== null && !(typeof value === 'string' && value.trim() === '')
}

function firstValue(source, keys) {
  const data = source && typeof source === 'object' ? source : {}
  for (const key of keys) {
    if (hasValue(data[key])) return data[key]
  }
  return 0
}

function firstVipList(source, depth = 0, seen = []) {
  if (Array.isArray(source)) return source
  if (!source || typeof source !== 'object' || depth > 6 || seen.includes(source)) return []
  seen.push(source)
  for (const key of VIP_LIST_KEYS) {
    if (Array.isArray(source[key])) return source[key]
  }
  const nestedKeys = [...VIP_LIST_KEYS, ...VIP_ENVELOPE_KEYS]
  for (const key of nestedKeys) {
    const list = firstVipList(source[key], depth + 1, seen)
    if (list.length) return list
  }
  return []
}

function firstVipRecordObject(source) {
  if (Array.isArray(source)) return source.find(item => item && typeof item === 'object') || {}
  if (!source || typeof source !== 'object') return {}
  for (const key of ['account', 'profile', 'user', 'userInfo', 'member', 'current', 'currentVip', 'info']) {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) return source[key]
  }
  for (const key of ['list', 'records', 'dataList', 'items', 'pageList']) {
    const records = source[key]
    if (Array.isArray(records)) {
      const record = records.find(item => item && typeof item === 'object')
      if (record) return record
    }
  }
  return {}
}

function normalizeVipAccount(content) {
  const source = content && typeof content === 'object' ? { ...content, ...firstVipRecordObject(content) } : {}
  return {
    ...source,
    vipLevel: toNumber(firstValue(source, ['vipLevel', 'vip_level', 'level'])),
    betAmount: toNumber(firstValue(source, ['betAmount', 'bet_amount', 'effectiveBetAmount'])),
    nextBetAmount: toNumber(firstValue(source, ['nextBetAmount', 'next_bet_amount', 'nextEffectiveBetAmount'])),
    rechargeAmount: toNumber(firstValue(source, ['rechargeAmount', 'recharge_amount', 'balance', 'totalBalance', '_balUsable', 'balUsable', 'availableBalance'])),
    nextRechargeAmount: toNumber(firstValue(source, ['nextRechargeAmount', 'next_recharge_amount']))
  }
}

function normalizeVipRow(row) {
  const source = row && typeof row === 'object' ? row : {}
  return {
    ...source,
    vipLevel: toNumber(firstValue(source, ['vipLevel', 'vip_level', 'level'])),
    rechargeAmount: toNumber(firstValue(source, ['rechargeAmount', 'recharge_amount', 'balance', 'totalBalance', '_balUsable', 'balUsable', 'availableBalance'])),
    upgradeBonus: toNumber(firstValue(source, ['upgradeBonus', 'upgrade_bonus'])),
    signReward: toNumber(firstValue(source, ['signReward', 'sign_reward'])),
    monthlyBonus: toNumber(firstValue(source, ['monthlyBonus', 'monthly_bonus']))
  }
}

export default {
  name: 'Vip',
  components: {},
  data() {
    return {
      InitDate: [],
      InitDate2: {},
      percentage: 0,
      percentage1: 0,
      vipReadError: ''
    }
  },
  mounted() {
    this.VipInit()
  },
  methods: {
    getBackgroundColor(i) {
      if (i === 0) {
        return {
          background: `${
            'url(' + require('@/assets/img/vip/V0-bg.png') + ') no-repeat'
          } `
        }
      } else if ([1, 2, 3, 4].includes(i)) {
        return {
          background: `${
            'url(' + require('@/assets/img/vip/V1-bg.png') + ') no-repeat'
          } `
        }
      } else if ([5, 6, 7, 8].includes(i)) {
        return {
          background: `${
            'url(' + require('@/assets/img/vip/V5-bg.png') + ') no-repeat'
          } `
        }
      } else if ([9, 10, 11].includes(i)) {
        return {
          background: `${
            'url(' + require('@/assets/img/vip/V9-bg.png') + ') no-repeat'
          } `
        }
      } else if ([12, 13, 14].includes(i)) {
        return {
          background: `${
            'url(' + require('@/assets/img/vip/V12-bg.png') + ') no-repeat'
          } `
        }
      } else if ([15, 16].includes(i)) {
        return {
          background: `${
            'url(' + require('@/assets/img/vip/V15-bg.png') + ') no-repeat'
          } `
        }
      } else if ([17, 18].includes(i)) {
        return {
          background: `${
            'url(' + require('@/assets/img/vip/V17-bg.png') + ') no-repeat'
          } `
        }
      } else if ([19, 20].includes(i)) {
        return {
          background: `${
            'url(' + require('@/assets/img/vip/V19-bg.png') + ') no-repeat'
          } `
        }
      }
    },
    resetVipReadState() {
      this.InitDate = []
      this.InitDate2 = {
        vipLevel: 0,
        betAmount: 0,
        nextBetAmount: 0,
        rechargeAmount: 0,
        nextRechargeAmount: 0
      }
      this.percentage = 0
      this.percentage1 = 0
    },
    async VipInit() {
      try {
        const data = await VipInit()
        if (handleNeedLogin(this, data, this.$lang.login_txt11 || this.$lang.Entrar || 'Login Now', { isValue: 'isLogin' }, { replace: true })) return
        if (isReadOk(data)) {
          this.vipReadError = ''
          const content = contentOf(data)
          const vipRows = firstVipList(content)
          this.InitDate = toArray(vipRows.length ? vipRows : firstVipList(data)).map(normalizeVipRow)
          this.InitDate2 = normalizeVipAccount(content)
          const betTarget = toNumber(this.InitDate2.nextBetAmount)
          const rechargeTarget = toNumber(this.InitDate2.nextRechargeAmount)
          this.percentage1 = betTarget > 0
            ? Math.min((toNumber(this.InitDate2.betAmount) / betTarget) * 100, 100)
            : 0
          this.percentage = rechargeTarget > 0
            ? Math.min((toNumber(this.InitDate2.rechargeAmount) / rechargeTarget) * 100, 100)
            : 0
        } else {
          this.vipReadError = failMessage(data, 'This feature is temporarily unavailable. Please try again later.')
          if (typeof this.$toast === 'function') this.$toast({ message: this.vipReadError, icon: 'cross' })
        }
      } catch (e) {
        const networkFallback = this.$lang.network_error === 'Network error'
          ? 'This feature is temporarily unavailable. Please try again later.'
          : (this.$lang.network_error || 'This feature is temporarily unavailable. Please try again later.')
        this.vipReadError = failMessage(e, networkFallback)
        if (typeof this.$toast === 'function') this.$toast({ message: this.vipReadError, icon: 'cross' })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.vip-read-diagnostic {
  width: 94%;
  margin: 12px auto 0;
  padding: 10px 12px;
  border: 1px solid rgba(245, 158, 11, 0.45);
  border-radius: 8px;
  background: rgba(245, 158, 11, 0.12);
  color: #f8d48a;
  font-size: var(--vk-fs-xs);
  line-height: 18px;
}

.content-c {
  padding: 5% 3%;
}
.content-c--i {
  position: relative;
  border-radius: 13px;
  padding: 16px 10px;
  background: linear-gradient(to right, #313234, #323c37, #314c3e);
  box-shadow: 0 0px 7px black;
  margin-bottom: 19px;
}
.content-c--img {
  position: absolute;
  right: -10px;
  top: 32px;
  z-index: 1;
}
.content-info2 {
  background: url(../../../assets/img/vip/mine-bg.png) no-repeat;
  border-radius: 12px;
  background-size: 100% 100% !important;
  width: 95%;
  padding: 8px 0;
  // position: absolute;
  // left: 0;
  // right: 0;
  margin: 20px auto 0;
  max-width: 422px;
  height: 180px;
}
.content-info2--c {
  display: flex;
  width: 100%;
}
.content-line {
  display: flex;
  background: #a18b58;
  margin-top: 10px;
  height: 1px;
  width: 100%;
}
// .content-info2--t {
// color: #ffffff;
// margin-right: 8px;
// font-style: italic;
// font-weight: bold;
//}

.content-c3 {
  width: 94%;
  margin: 0 auto 30px;
}
.content-c3--t {
  margin-top: -3px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px 12px 0 0;
  background: @cont-bg;
  padding: 10px 0;
  text-align: center;
  p {
    width: 20%;
  }
}
.content-c3--t2 {
  display: flex;
  flex: 1;
  text-align: center;
  align-items: center;
  justify-content: space-between;
  background: @cont-bg;
  padding-top: 3px;
  padding-bottom: 3px;
  // padding: 0 3%;
}
.content-c3--t2 img {
  object-fit: contain;
  display: block;
  margin: 0 2px 0 10px;
}
.content-c3--t2 p {
  width: 20%;
  padding: 15px 0;
  text-align: center;
}
.content-c3--t3 {
  border-radius: 0 0 15px 15px;
  height: 0px;
  background: @cont-bg;
}
// .vip-tag {
//   background: linear-gradient(to right, #676767, #525252, #676767) !important;
//   padding: 3px 15px 3px 10px;
//   border-radius: 0 5px 8px 0px;
//   margin-right: 15px;
//   margin-left: -10px;
// }
.vip-tag2 {
  background: #575130 !important;
  padding: 1px 10px;
  border-radius: 0 3px 6px 0px;
  margin-left: -10px;
  // margin-right: 10px;
  color: #ffffff;
  font-style: italic;
  font-weight: bold;
}
.vip-tag3 {
  background: #575130 !important;
  border-radius: 0 5px 8px 0px !important;
  padding: 2px 5px 2px 8px;
  margin-left: -10px;
  color: #ffffff;
  font-weight: bold;
  font-style: italic;
}
.content-c3 :last-child {
  border-radius: 0 0 12px 12px;
}
::v-deep .van-progress {
  border-radius: 15px;
  // border-radius: 10px;
  // background: #202447;
  width: 245px !important;

  // border: 1px solid #f6eec8;
  // padding: 1px;
}
.progress-bg {
  ::v-deep .van-progress__portion {
    background: linear-gradient(to bottom, #fff0b4, #e5d48d) !important;
    height: 12px;
    margin: 1px 2px 1px 2px;
    border-radius: 20px;
    width: 241px !important;
  }
}
</style>
